import { Timeline, COMPONENT_NAME } from './timeline';

/**
 * jQuery component wrapper for the Timeline
 * @param {object} [settings] incoming settings
 * @returns {jQuery[]} elements being acted on
 */
$.fn.timeline = function (settings) {
  return this.each(function () {
    let instance = $.data(this, COMPONENT_NAME);
    if (instance) {
      instance.updated(settings);
    } else {
      instance = $.data(this, COMPONENT_NAME, new Timeline(this, settings));
    }
  });
};
